//
// トーストを呼び出す
//
import { toast } from './toast.js';

window.addEventListener("load", (_event) => {
  const data = document.querySelector("[data-toast-message]");
  if (!data) return;

  const message = data.dataset.toastMessage;

  const mainContent = document.querySelector(".main");

  toast(message, mainContent);
});
